import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';

@Component({
  selector: 'app-basic-card-footer',
  standalone: false,
  templateUrl: './basic-card-footer.component.html',
})
export class BasicCardFooterComponent extends AppBaseComponent {
  @Input() isSaveDisabled = false;
  @Input() showCancelButton = true;
  @Output() save = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  onSave(): void {
    this.save.emit();
  }

  onCancel(): void {
    this.back.emit();
  }
}
